"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.removeToken = removeToken;
exports.setToken = setToken;
// import Cookies from 'js-cookie'

var TokenKey = 'Admin-Token';
function getToken() {
  var token = window.localStorage.getItem(TokenKey);
  return token;
  // return Cookies.get(TokenKey)
}
function setToken(token) {
  window.localStorage.setItem(TokenKey, token);
  return token;
  // return Cookies.set(TokenKey, token)
}
function removeToken() {
  window.localStorage.removeItem(TokenKey);
  return null;
  // return Cookies.remove(TokenKey)
}